import type { StateCreator } from "zustand";
import type { TournamentProgressState } from "../types/types";
import type { PlayerTournamentProgressSchema } from "@/types/generated-types";
import { matchesKey } from "@/campaigns/campaign-key";
import type { AppStore } from "./app.store";

export interface TournamentProgressSlice {
  tournamentProgress: TournamentProgressState;

  setTournamentProgressSubscribed: (subscribed: boolean) => void;
  setTournamentProgressLoading: (loading: boolean) => void;
  setTournamentProgressItems: (items: PlayerTournamentProgressSchema[]) => void;
  clearTournamentProgress: () => void;
}

const initialTournamentProgressState: TournamentProgressState = {
  subscribed: false,
  loading: false,
  items: [],
};

export const createTournamentProgressSlice: StateCreator<TournamentProgressSlice> = (set) => ({
  tournamentProgress: initialTournamentProgressState,

  setTournamentProgressSubscribed: (subscribed) =>
    set((state) => ({
      tournamentProgress: { ...state.tournamentProgress, subscribed, loading: false },
    })),

  setTournamentProgressLoading: (loading) =>
    set((state) => ({
      tournamentProgress: { ...state.tournamentProgress, loading },
    })),

  setTournamentProgressItems: (items) =>
    set((state) => ({
      tournamentProgress: { ...state.tournamentProgress, items },
    })),

  clearTournamentProgress: () =>
    set({ tournamentProgress: initialTournamentProgressState }),
});

/**
 * Select progress for a campaign by custom_id or string id.
 */
export function selectTournamentProgressByCampaignId(
  state: AppStore,
  campaignId: string
): PlayerTournamentProgressSchema | undefined {
  return state.tournamentProgress.items.find((p) => matchesKey(p, campaignId));
}
